// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLandingLayout-cls1_TNV","cls2":"CiterightLandingLayout-cls2_ITp CiterightLandingLayout-cls1_TNV"};